/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckCompanyList {
  readonly id: string;
  readonly name: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly total_raised: number;
}
